module.exports = __webpack_public_path__ + "assets/66f02f9e3ddb45f41e513e60858ab561.png";